import { grayColor } from '../../jss/material-dashboard-pro-react'

const cardFooterStyle = {
  cardFooter: {
    padding: '0',
    paddingTop: 'var(--sp-3, 12px)',
    margin: '0 var(--sp-4, 16px) var(--sp-3, 12px)',
    borderRadius: '0',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    backgroundColor: 'transparent',
    border: '0',
  },
  cardFooterProfile: {
    marginTop: '-15px',
  },
  cardFooterPlain: {
    paddingLeft: 'var(--sp-1, 4px)',
    paddingRight: 'var(--sp-1, 4px)',
    backgroundColor: 'transparent',
  },
  cardFooterPricing: {
    zIndex: '2',
  },
  cardFooterTestimonial: {
    display: 'block',
  },
  cardFooterStats: {
    borderTop: '1px solid' + grayColor[8],
    marginTop: '20px',
    '& svg': {
      position: 'relative',
      top: '4px',
      marginRight: '3px',
      marginLeft: '3px',
      width: '16px',
      height: '16px',
    },
    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
      position: 'relative',
      top: '4px',
      marginRight: '3px',
      marginLeft: '3px',
      fontSize: '16px',
      lineHeight: '16px',
    },
  },
  cardFooterChart: {
    borderTop: '1px solid' + grayColor[8],
  },
}

export default cardFooterStyle
